import { MaterialIcons } from "~/app/common/Icon";
import { SearchMachine, SearchUser } from "~/types";

export interface AttachmentsValue {
    images: File[];
    pdfs: File[];
}

export interface Attachment {
    name: string;
    url: string
}

export interface ExternalResource {
    id: string;
    title: string;
    type: number;
    url: string;
}

export interface ChecklistItemAssetMap {
    [assetId: string]: ChecklistItem[]
}

export interface ChecklistItem {
    id: string;
    title: string;
    isChecked: boolean;
}

export interface TrainingFormType {
    excavators: SearchMachine[],
    title: string
    participants: SearchUser[],
    instructor: number,
    trainingDate: string,
    checklist: ChecklistItem[],
    externalResources: ExternalResource[],
    commentFromInstructor: string,
    signConfirm: boolean
}

export interface Training {
    id: string,
    title: string,
    instructor: string,
    trainingDate: string,
    status: TRAINING_STATUS
}

export interface TrainingResponsePayload {
    success: boolean,
    trainingId: string
}

export interface TrainingDetail {
    id: string,
    title: string,
    participants: SearchUser[],
    instructor: SearchUser,
    trainingDate: string,
    checklist: ChecklistItem[],
    externalResources: ExternalResource[],
    images: Attachment[],
    pdfs: Attachment[],
    commentFromInstructor: string,
    comment: string,
    status: TRAINING_STATUS,
}

export interface TrainingApprovalPayload {
    status: TRAINING_STATUS,
    comment: string
}

export type FileType = 1 | 2 | 3 | 4;

export const typeMap: Record<FileType, MaterialIcons> = {
    1: 'video_file',
    2: 'picture_as_pdf',
    3: 'link',
    4: 'link',
};

export const getType = (type: number): MaterialIcons => {
    return typeMap[type as FileType] ?? 'link';
};

export enum TRAINING_STATUS {
    NOTAPPLICABLE = 0,
    PENDING = 1,
    APPROVE = 2,
    REJECT = 3
}

export const DEFAULT_MAX_IMAGE_SIZE = 10;
export const DEFAULT_MAX_NUMBER_OF_IMAGES = 5;
export const DEFAULT_MAX_PDF_SIZE = 20;
export const DEFAULT_MAX_NUMBER_OF_PDFS = 2;